import { useState } from "react";
import axios from "axios";

const usePincode = (pincode) => {
  const [pincodeMessage, setPincodeMessage] = useState("");
  const [pincodePrice, setPincodePrice] = useState(null);
  const [checkingPincode, setCheckingPincode] = useState(false);

  const handlePincodeCheck = async () => {
    if (!pincode || pincode.trim().length !== 6) {
      setPincodePrice(null);
      setPincodeMessage("Please enter a valid 6-digit pincode.");
      return;
    }
    setCheckingPincode(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/service-pincode-check`,
        { params: { pincode: pincode.trim() } }
      );
      const { available, price, message } = response.data;
      setPincodeMessage(message);
      setPincodePrice(available ? price : null);
    } catch (err) {
      setPincodePrice(null);
      setPincodeMessage("Could not check pincode availability. Please try again.");
    } finally {
      setCheckingPincode(false);
    }
  };

  return { pincodeMessage, pincodePrice, checkingPincode, handlePincodeCheck };
};

export default usePincode;
